import { render, staticRenderFns } from "./PaymentReturn.vue?vue&type=template&id=4ae4e03c&scoped=true"
import script from "./PaymentReturn.vue?vue&type=script&lang=js"
export * from "./PaymentReturn.vue?vue&type=script&lang=js"
import style0 from "./PaymentReturn.vue?vue&type=style&index=0&id=4ae4e03c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae4e03c",
  null
  
)

export default component.exports